module.exports = __webpack_public_path__ + "img/02.cbc7c3e4.png";